import React from "react"

import {IonCol, IonGrid, IonRow} from "@ionic/react"

import {TimeLimit as ItemType} from "../../types/TimeLimit"

import ViewHeader           from "./View/Header"
import ViewItemGroupInfo    from "./View/ItemGroupInfo"
import ViewItemGroupLinked  from "./View/ItemGroupLinked"
import ButtonSync           from "./View/ButtonSync";
import ButtonDelete         from "./View/ButtonDelete";

export interface formProps {
    item: ItemType
}

const View: React.FC<formProps> = ({ item }) => {

    const formButtons = () => {
        if (item !== undefined) {
            return (
                <>
                    {item.options?.isSynchronizable && <ButtonSync item={item} />}
                    {item.options?.isDeletable && <ButtonDelete item={item} />}
                </>
            )
        }
    }

    return (
        <div className="ion-text-center">
            <ViewHeader        item={item} />
            <ViewItemGroupInfo item={item} />
            <ViewItemGroupLinked item={item} />

            <IonGrid className="ion-margin-top">
                <IonRow>
                    <IonCol className="ion-text-right">
                        {formButtons()}
                    </IonCol>
                </IonRow>
            </IonGrid>
        </div>
    )
}

export default View